module.exports = __webpack_public_path__ + "img/流体力学4_5_4.cd6fe289.jpg";